<template>
  <div class="service-plan">
    <div style="margin-bottom:0.8rem">
      <el-button @click="addPlan" size="small" type="success" icon="el-icon-plus">添加计划</el-button>
    </div>
    
    <div v-for="(msg,index) in savePlan" :key="index" class="save-box">
      <div class="service-plan-input">
        <span class="trend-title">设备检修计划数据</span>
        <el-select v-model="valueDef" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
                <el-button @click="removePlan(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="service-plan-input">
        <span class="trend-title">检修日期</span>
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="msg.inspectTime"
          type="date"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="service-plan-input">
        <span class="trend-title">检修类型</span>
        <el-select v-model="msg.inspectType" placeholder="请选择">
          <el-option
            v-for="item in thingType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

      </div>
      <div class="service-plan-input">
        <span class="trend-title">设备名称</span>
        <el-input type="text" placeholder="请输入" v-model="msg.devName"></el-input>
      </div>
      <div class="service-plan-input">
        <span class="trend-title">设备所在区域</span>
        <el-input type="text" placeholder="请输入" v-model="msg.devArea"></el-input>
      </div>
      <div class="service-plan-input">
        <span class="trend-title">检修负责人</span>
        <el-input type="text" placeholder="请输入" v-model="msg.inspectUser"></el-input>
        
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="devPlanLoading" size="small" @click="saveDevPlan" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/device/device'
export default {
  data(){
    return{
      devPlanLoading:false,//加载状态
      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      thingType: [
        {
          value: 1,
          label: '常规保养'
        }, 
        {
          value: 2,
          label: '损坏维修'
        },
        {
          value: 3,
          label: '其他'
        },
      ],
      valueDef:1,

      savePlan:[
        {inspectTime:'',inspectType:'',devName:'',devArea:'',inspectUser:''}
      ]
    }
  },
  mounted(){
    this.getDevPlan()
  },
  methods:{
    //保存数据
    saveDevPlan(){
      this.devPlanLoading = true;
      api.saveInspect(this.savePlan).then(res=>{
        if(res.code==10000){
          this.devPlanLoading = false;
          this.getDevPlan()
          this.$message.success('保存成功');
        }else{
          this.devPlanLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据
    getDevPlan(){
      api.getInspect().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.savePlan = res.data
          }
        }
      })
    },
    //删除一行检修计划
    removePlan(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delInspect([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getDevPlan()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.savePlan.splice(index,1)
      }
    },
    //添加一行检修计划
    addPlan(){
      this.savePlan.push({inspectTime:'',inspectType:'',devName:'',devArea:'',inspectUser:''})
    },
  }
}
</script>
<style lang="less" scoped>
.service-plan{ padding-top: 10px;
  .service-plan-input{ display:inline-flex; width: 48%; flex-direction: row; margin-bottom: 15px; margin-right: 15px;
    .el-input,.el-select{ flex:1;}
    .trend-title{ width: 7rem;}
  } 
  .service-plan-input:nth-child(1){ width: 100%; margin-bottom: 1rem; display: block;
    .trend-title{ width: 9rem;}
  }
  .save-box{ display:inline-block; border: #3570ff solid 1px; position: relative; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; }
}
</style>